import { ESortType } from 'affiny-core/modules/api/core/resources/matchlist.resource';
import { ActionsUnion, createAction } from '../helpers';
import {
  IGetMatchListSuccessPayload,
  IGetSortedMatchListSuccessPayload,
} from './types';

export enum EMatchesActionType {
  GET_AFFINY_MATCH_LIST = 'MATCHES/AFFINY/GET',
  GET_AFFINY_MATCH_LIST_SUCCESS = 'MATCHES/AFFINY/GET_SUCCESS',
  GET_AFFINY_ADDITIONAL_MATCH_LIST = 'MATCHES/ADDITIONAL/AFFINY/GET',
  GET_AFFINY_ADDITIONAL_MATCH_LIST_SUCCESS = 'MATCHES/ADDITIONAL/AFFINY/GET_SUCCESS',
  REPLACE_AFFINY_MATCH_LIST_BY_ADDITIONAL_MATCHLIST = 'REPLACE/AFFINY/MATCH_LIST/BY/ADDITIONAL_MATCHLIST',
  GET_SORT_MATCH_LIST = 'MATCHES/SORT/GET',
  GET_SORT_MATCH_LIST_SUCCESS = 'MATCHES/SORT/GET_SUCCESS',
  SET_SORT_TYPE = 'MATCHES/SORT/SET_SORT_TYPE',
  SET_SORT_TYPE_SUCCESS = 'MATCHES/SORT/SET_SORT_TYPE_SUCCESS',
  RESET_MATCH_LIST = 'MATCHES/SORT/RESET',
  REMOVE_USER_AFFINY_MATCHES = 'MATCHES/AFFINY/USER_REMOVE',
  GET_USER_AFFINY_MATCHES = 'MATCHES/AFFINY/USER/GET',
}

export const DEFAULT_PAGE_SIZE = 10;

export const matchesActions = {
  getAffinyMatches: () =>
    createAction(EMatchesActionType.GET_AFFINY_MATCH_LIST),
  getAffinyMatchesSuccess: (payload: IGetMatchListSuccessPayload) =>
    createAction(EMatchesActionType.GET_AFFINY_MATCH_LIST_SUCCESS, payload),
  getAffinyAdditionalMatches: (excludedMembers?: string[]) =>
    createAction(EMatchesActionType.GET_AFFINY_ADDITIONAL_MATCH_LIST, {
      excludedMembers,
    }),
  getAffinyAdditionalMatchesSuccess: (payload: IGetMatchListSuccessPayload) =>
    createAction(
      EMatchesActionType.GET_AFFINY_ADDITIONAL_MATCH_LIST_SUCCESS,
      payload
    ),
  replaceMatchListByAdditionalMatchList: () =>
    createAction(
      EMatchesActionType.REPLACE_AFFINY_MATCH_LIST_BY_ADDITIONAL_MATCHLIST
    ),
  getMatches: (reset = false) =>
    createAction(EMatchesActionType.GET_SORT_MATCH_LIST, { reset }),
  getMatchesSuccess: (payload: IGetSortedMatchListSuccessPayload) =>
    createAction(EMatchesActionType.GET_SORT_MATCH_LIST_SUCCESS, payload),
  setSortType: (sortType: ESortType) =>
    createAction(EMatchesActionType.SET_SORT_TYPE, { sortType }),
  setSortTypeSuccess: (sortType: ESortType) =>
    createAction(EMatchesActionType.SET_SORT_TYPE_SUCCESS, { sortType }),
  resetMatchesList: () => createAction(EMatchesActionType.RESET_MATCH_LIST),
  removeUserAffinyMatches: (accountId: string) =>
    createAction(EMatchesActionType.REMOVE_USER_AFFINY_MATCHES, { accountId }),
  getMatchListUser: (accountId: string) =>
    createAction(EMatchesActionType.GET_USER_AFFINY_MATCHES, { accountId }),
};

export type TMatchesActions = ActionsUnion<typeof matchesActions>;
